import { render, staticRenderFns } from "./SettingsMainPage.vue?vue&type=template&id=80e5dcfa&scoped=true&lang=pug&"
import script from "./SettingsMainPage.vue?vue&type=script&lang=js&"
export * from "./SettingsMainPage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMainPage.vue?vue&type=style&index=0&id=80e5dcfa&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e5dcfa",
  null
  
)

export default component.exports